import React, { useState, useEffect } from "react";
import { Badge, Button } from "react-bootstrap";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { setLastEarnedPoints } from "../../redux/notificaciones/notificacionesActions";
import { useSelector, useDispatch } from "react-redux";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { PLAN_VAR, VARIABLES_POLITICA } from "../../constants/Gamification";
import {
  misPuntos,
  calcularDescuentoEquivalente,
} from "../../helpers/gamification";
import { OBJECTIVES } from "../../constants/Gamification";
import { fetchPrestacionesTerminadasEmpresa } from "../../services/firebase/prestaciones/index";
import { getPrestacionesCountByEmpresaMonth } from "../../services/firebase/prestaciones/index";
import { getMovimientosCountByEmpresaMonth } from "../../services/firebase/movimientos/index";
import { getPacientesCountByEmpresa } from "../../services/firebase/pacientes/index";
import { setTotalPoints } from "../../redux/notificaciones/notificacionesActions";
import { getCitasCountByEmpresaMonth } from "../../services/firebase/citas";
import { Link } from "react-router-dom";
import { calcularPuntosGamificadosconst } from "../../helpers/gamification";

import { fetchMensajesEnviadosDesdeUltimoPago } from "../../services/firebase/resumenMensajes/index";
import { obtenerDatosUsuarios } from "../../services/firebase/perfilesUsuarios/index";
import { getPlanes } from "../../services/firebase/planes/index";

const getPlanLimits = (empresa, planesList = []) => {
  const dbMembresia = empresa.membresia || {};

  let planName = "FREE";
  if (dbMembresia.plan) {
    if (typeof dbMembresia.plan === "object") {
      planName = dbMembresia.plan.nombre || dbMembresia.plan.plan || "FREE";
    } else {
      planName = dbMembresia.plan;
    }
  } else if (empresa.tipoMembresia) {
    planName = empresa.tipoMembresia;
  }

  const dbPlan = planesList.find(
    (p) =>
      p.id.toLowerCase() === planName.toLowerCase() ||
      p.nombre?.toLowerCase() === planName.toLowerCase(),
  );

  const isPrepago = (empresa.tipoMembresia || "").toUpperCase() === "PREPAGO";
  if (isPrepago) {
    return {
      plan: "PREPAGO",
      usuarios: 1,
      pacientes: 50,
      prestaciones: 100,
      maxMensajesWhatsapp: empresa.saldoMensajesWhatsapp || 0,
    };
  }

  const dbFreePlan =
    planesList.find(
      (p) =>
        p.id.toLowerCase() === "free" || p.nombre?.toLowerCase() === "free",
    ) || {};

  const limitSource =
    typeof dbMembresia.plan === "object" ? dbMembresia.plan : {};

  return {
    plan: planName,
    usuarios:
      dbMembresia.usuarios ||
      limitSource.limiteUsuarios ||
      limitSource.usuarios ||
      dbPlan?.limiteUsuarios ||
      dbPlan?.usuarios ||
      dbFreePlan.limiteUsuarios ||
      dbFreePlan.usuarios ||
      0,
    pacientes:
      dbMembresia.pacientes ||
      limitSource.limitePacientes ||
      limitSource.pacientes ||
      dbPlan?.limitePacientes ||
      dbPlan?.pacientes ||
      dbFreePlan.limitePacientes ||
      dbFreePlan.pacientes ||
      0,
    prestaciones:
      dbMembresia.prestaciones ||
      limitSource.limitePrestaciones ||
      limitSource.prestaciones ||
      dbPlan?.limitePrestaciones ||
      dbPlan?.prestaciones ||
      dbFreePlan.limitePrestaciones ||
      dbFreePlan.prestaciones ||
      0,
    maxMensajesWhatsapp:
      dbMembresia.maxMensajesWhatsapp ||
      limitSource.maxMensajesWhatsapp ||
      dbPlan?.maxMensajesWhatsapp ||
      dbFreePlan.maxMensajesWhatsapp ||
      0,
  };
};

const getColorScale = (percent) => {
  if (percent >= 100) {
    return {
      bgColor: "#fdf2f2",
      borderColor: "#f8b4b4",
      textColor: "#dc3545",
      icon: "🚨",
      statusText: "Límite Excedido",
    };
  }
  if (percent >= 90) {
    return {
      bgColor: "#fff3cd",
      borderColor: "#ffeiba",
      textColor: "#856404",
      icon: "⚠️",
      statusText: "Límite Crítico",
    };
  }
  if (percent >= 75) {
    return {
      bgColor: "#fff9db",
      borderColor: "#ffe8cc",
      textColor: "#d97706",
      icon: "⚠️",
      statusText: "Límite Cercano",
    };
  }
  // 60% a 74%
  return {
    bgColor: "#e7f5ff",
    borderColor: "#d0ebff",
    textColor: "#0c8de3",
    icon: "ℹ️",
    statusText: "Límite en Progreso",
  };
};

const Notificationes = () => {
  const empresa = useSelector((state) => state.empresa);

  const dispatch = useDispatch();
  const notificaciones = useSelector((state) => state.notificaciones);

  const [loading, setLoading] = useState(true);
  const [warnings, setWarnings] = useState([]);

  useEffect(() => {
    async function fetchStats() {
      if (!empresa || !empresa.id) return;
      setLoading(true);
      const currentDate = new Date();
      const empresaId = empresa.id;
      try {
        const [
          pacientes,
          movimientos,
          prestaciones,
          citas,
          usuariosData,
          whatsappCount,
          planesList,
        ] = await Promise.all([
          getPacientesCountByEmpresa(empresaId),
          getMovimientosCountByEmpresaMonth(currentDate, empresaId),
          getPrestacionesCountByEmpresaMonth(currentDate, empresaId),
          getCitasCountByEmpresaMonth(currentDate, empresaId),
          obtenerDatosUsuarios(empresaId),
          fetchMensajesEnviadosDesdeUltimoPago(empresaId, empresa.fecUltPago),
          getPlanes(),
        ]);

        const totalPoints = calcularPuntosGamificadosconst(
          pacientes,
          prestaciones,
          citas,
          movimientos,
        );
        dispatch(setTotalPoints(totalPoints));

        // Calcular límites del plan y sus advertencias
        const limits = getPlanLimits(empresa, planesList || []);
        const counts = {
          pacientes: pacientes || 0,
          prestaciones: prestaciones || 0,
          usuarios: Array.isArray(usuariosData) ? usuariosData.length : 0,
          whatsapp: whatsappCount || 0,
        };

        const planWarnings = [];
        const checkLimit = (current, limit, label) => {
          const limitVal = Number(limit) || 0;
          const currentVal = Number(current) || 0;
          if (limitVal > 0) {
            const ratio = currentVal / limitVal;
            if (ratio >= 0.6) {
              planWarnings.push({
                label,
                current: currentVal,
                limit: limitVal,
                percent: Math.round(ratio * 100),
                isExceeded: ratio >= 1.0,
              });
            }
          }
        };

        checkLimit(counts.pacientes, limits.pacientes, "Pacientes Registrados");
        checkLimit(
          counts.prestaciones,
          limits.prestaciones,
          "Prestaciones Realizadas",
        );
        checkLimit(counts.usuarios, limits.usuarios, "Usuarios de Consultorio");
        checkLimit(
          counts.whatsapp,
          limits.maxMensajesWhatsapp,
          "Consumo WhatsApp",
        );

        setWarnings(planWarnings);
      } catch (err) {
        console.error("Error fetching notification stats:", err);
      } finally {
        setLoading(false);
      }
    }
    if (empresa && empresa.id) fetchStats();
  }, [empresa]);

  const MensajeMetaCumplida = (puntos, diasFaltantes, descuento) => {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <div style={{ fontWeight: 500, color: "#2d3a4b", fontSize: 16 }}>
          <span style={{ color: "#0d6efd", fontWeight: 700 }}>{puntos}</span> /{" "}
          <span style={{ color: "#888" }}>
            {VARIABLES_POLITICA.PUNTAJE_MAXIMO}
          </span>{" "}
          puntos
        </div>
        <div style={{ fontSize: 15, color: "#28a745" }}>
          ¡Felicidades has obtenido los puntos requeridos. Tu descuento para la
          siguiente facturación es: S/ <strong>{descuento.toFixed(2)}</strong>!
        </div>
        <div style={{ fontSize: 15, color: "#555" }}>
          <span style={{ color: "#ffc107", fontWeight: 600 }}>
            ⏳ Durante los próximos <strong>{diasFaltantes}</strong> días
            aplicaremos este descuento a tu facturación.
          </span>
        </div>
      </div>
    );
  };

  const MensajeMetaFaltante = (puntos, siguienteFacturacion, diasFaltantes) => {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <div style={{ display: "flex", gap: 3 }}>
          <div style={{ fontWeight: 500, color: "#2d3a4b", fontSize: 16 }}>
            <span style={{ color: "#0d6efd", fontWeight: 700 }}>{puntos}</span>{" "}
            puntos
          </div>
          <div style={{ fontSize: 15, color: "#555" }}>
            {"-->"}
            <span style={{ color: "#dc3545", fontWeight: 600 }}>S/ -0.00</span>.
          </div>
        </div>
        <div style={{ fontSize: 15, color: "#555" }}>
          <span style={{ color: "#0d6efd", fontWeight: 600 }}>
            ⏳ La fecha de la siguiente facturación es :{" "}
            <strong>{siguienteFacturacion.toLocaleDateString()}</strong>. Te
            quedan <strong>{diasFaltantes}</strong> días para acumular mas
            puntos.
          </span>
        </div>
      </div>
    );
  };

  const MensajePlanExpirado = () => {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <div style={{ fontWeight: 500, color: "#2d3a4b", fontSize: 16 }}>
          Tu periodo de prueba ha expirado.
        </div>
        <div style={{ fontSize: 15, color: "#dc3545" }}>
          Por favor, contacta a tu administrador para más información.
        </div>
      </div>
    );
  };

  const MensajeAMostrar = () => {
    const puntos = notificaciones.totalPoints;
    const fechaInicio = empresa.fecIni
      ? (typeof empresa.fecIni.toDate === 'function' ? empresa.fecIni.toDate() : new Date(empresa.fecIni))
      : new Date(); // Convert Firestore timestamp to Date

    const tipoMembresia = empresa.tipoMembresia;
    const siguienteFacturacion = new Date(fechaInicio);
    const DIAS_MES = 30;

    siguienteFacturacion.setDate(siguienteFacturacion.getDate() + DIAS_MES); // Add days to date

    const fechaActual = new Date();
    const diasFaltantes = Math.ceil(
      (siguienteFacturacion - fechaActual) / (1000 * 60 * 60 * 24),
    );
    const descuento = calcularDescuentoEquivalente(puntos);

    if (puntos >= VARIABLES_POLITICA.PUNTAJE_MINIMO) {
      return MensajeMetaCumplida(puntos, diasFaltantes, descuento);
    } else {
      return MensajeMetaFaltante(puntos, siguienteFacturacion, diasFaltantes);
    }
  };

  const handleNotificationClick = () => {
    // Al hacer clic, reseteamos los puntos recién ganados para que el badge desaparezca.
    if (notificaciones.lastEarnedPoints > 0) {
      dispatch(setLastEarnedPoints(0));
    }
  };

  const popover = () => (
    <Popover
      id="popover-basic"
      style={{
        minWidth: 290,
        maxWidth: 350,
        borderRadius: 16,
        boxShadow: "0 4px 24px rgba(0,0,0,0.10)",
      }}
    >
      <Popover.Header
        as="h3"
        style={{
          background: "#0d6efd",
          color: "#fff",
          borderRadius: "16px 16px 0 0",
          fontWeight: 700,
          fontSize: 17,
          textAlign: "center",
        }}
      >
        <span role="img" aria-label="bell" style={{ marginRight: 8 }}>
          🔔
        </span>{" "}
        Notificaciones
      </Popover.Header>
      <Popover.Body
        style={{
          background: "#f8f9fc",
          borderRadius: "0 0 16px 16px",
          padding: 16,
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {/* Advertencias de Límites del Plan */}
          {warnings.length > 0 ? (
            warnings.map((w, idx) => {
              const scale = getColorScale(w.percent);
              return (
                <div
                  key={idx}
                  style={{
                    backgroundColor: scale.bgColor,
                    border: `1px solid ${scale.borderColor}`,
                    borderRadius: "10px",
                    padding: "10px 12px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      fontWeight: "bold",
                      color: scale.textColor,
                      fontSize: "13px",
                    }}
                  >
                    <span>
                      {scale.icon} {scale.statusText}
                    </span>
                  </div>
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#2d3a4b",
                      lineHeight: "1.4",
                    }}
                  >
                    Tu consultorio ha consumido el <strong>{w.percent}%</strong>{" "}
                    del límite de <strong>{w.label}</strong> ({w.current} de{" "}
                    {w.limit}).
                  </div>
                  <Link
                    to="/admin/reportes/whatsapp"
                    style={{
                      fontSize: "11px",
                      color: "#0d6efd",
                      textDecoration: "underline",
                      fontWeight: "600",
                      marginTop: "4px",
                    }}
                  >
                    Ver consumo →
                  </Link>
                </div>
              );
            })
          ) : (
            <div
              style={{
                textAlign: "center",
                padding: "10px 0",
                color: "#6c757d",
                fontSize: "13px",
              }}
            >
              <span
                role="img"
                aria-label="check"
                style={{ marginRight: 6, color: "#28a745", fontSize: "16px" }}
              >
                ✓
              </span>
              No tienes notificaciones pendientes.
            </div>
          )}
        </div>
      </Popover.Body>
    </Popover>
  );

  if (loading) return null;

  return (
    <>
      <OverlayTrigger
        trigger="click"
        rootClose
        placement="bottom"
        overlay={popover()}
      >
        <Button
          variant="info"
          onClick={handleNotificationClick}
          className="d-flex align-items-center justify-content-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="currentColor"
            className="bi bi-bell-fill"
            viewBox="0 0 16 16"
            style={{ marginRight: warnings.length > 0 ? "4px" : "0" }}
          >
            <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2m.995-14.901a1 1 0 1 0-1.99 0A5 5 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901" />
          </svg>
          {warnings.length > 0 ? (
            <Badge
              bg="danger"
              style={{ fontSize: "0.75rem", padding: "0.35em 0.5em" }}
            >
              !
            </Badge>
          ) : null}
        </Button>
      </OverlayTrigger>
    </>
  );
};

export default Notificationes;
